import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=68437e5a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68437e5a')) {
      api.createRecord('68437e5a', component.options)
    } else {
      api.reload('68437e5a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=68437e5a&", function () {
      api.rerender('68437e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xZMY1aiN6FwV/JS/imageCarousel.vue"
export default component.exports